module.exports = __webpack_public_path__ + "static/img/3.10d234e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/article/3.jpg
// module id = 5QNV
// module chunks = 1